import React from 'react'
import styled from 'styled-components';
import MainImg from '../../assets/main_bg.png'

const IntroBody = styled.div`
  section {
    @media (min-width: 769px) {
      padding: 0 20px;
    }
    background: url(${MainImg}) no-repeat;
    background-position: 50%;
    background-size: cover;
    padding-bottom: 180px;
    width: 100%;
    position: relative;

    .part {
      width: 1080px;
      margin: 0 auto;
      padding-top: 60px;
      padding-bottom: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .part-left {
        width: 50%;
        color: #fff;
        h1 {
          margin: 40px 0 20px 0;
          font-size: 30px;
          font-weight: 700;
          color: #fff;
          line-height: 42px;
        }
        .desc {
          line-height: 28px;
        }
        p {
          /* text-align: justify; */
          margin-bottom: 0px;
          position: relative;
          font-size: 15px;
          line-height: 22px;
          color: hsla(0,0%,100%,.8);
          &:first-child::before {
            content: '·';
            position: absolute;
            left: -15px;
            color: #fff;
            font-size: 30px;
          }
        }
      }

      >.iimg {
        margin-top: 40px;
        width: 42%;
        img {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 768px) {
    section {
      padding-bottom: 80px;
      .part {
        width: 100%;
        flex-wrap: wrap;
        padding: 0 20px;
        .part-left {
          h1 {
            margin: 40px 0 20px 0;
          }
          width: 100%;
          .mt30 {
            margin-top: 30px;
          }
        }
        >.iimg {
          width: 80%;
          flex-basis: 100%;
          padding: 0 25%;
          img {
            width: 100%;
          }
        }
      }
    }
  }
`;

export default function MainPanel(props) {
  return (
    <IntroBody>
      <section>
        <div className="part">
          <div className="part-left">
            {props.children}
          </div>
          <div className="iimg">
            <img src={props.IntroImg} alt="" />
          </div>
        </div>
      </section>
    </IntroBody>
  )
}
